export const getClubs = state => state.clubs.list;

export const getClubById = (state, id) => state.clubs.list.find(club => club.id === id);

export const getClubByID = id => state => state.clubs.list.find(club => club.id === Number(id));

export const getClubStatusById = id => state => state.clubs.status[id];

export const getClubStatuses = state => state.clubs.status;
